import React from 'react';
import { Helmet } from "react-helmet";



interface Rules {
    title?: string;
    subTitle?: string;
    listRules?: string[] | React.ReactNode[];
    description?: string | React.ReactNode;
    description2?: string | React.ReactNode;
}
export interface PolicyRules {
    title: string;
    content?: Rules[];
    subContent?: Rules[];
}

interface Props {
    pageTitle: string;
    policyRules: PolicyRules[];
}

const LegalPolicy: React.FC<Props> = ({
    pageTitle,
    policyRules = [],
}) => {
    return (
        <>
            <Helmet>
                <title>Redline Specialist Cars - {pageTitle}</title>
            </Helmet>
            <div className="min-h-screen bg-gray-100 dark:bg-custom-900 pb-12">
                <div className="max-w-4xl pt-6 mx-auto">
                    <div className="py-10">
                        <div className="mx-auto px-4 sm:px-6 lg:px-8">
                            <h1 className="text-3xl lg:text-5xl font-extrabold text-gray-900 dark:text-white text-center uppercase">{pageTitle}</h1>
                        </div>
                    </div>
                    <div className="mx-auto px-4 sm:px-6 lg:px-8">
                        <div className="overflow-hidden shadow rounded-lg">
                            <div className="flex flex-col gap-2">
                                {policyRules.map((rule, index) => (
                                    <div key={index} className="px-4 py-5 sm:p-6 font-light">
                                        <h2 className="text-2xl lg:text-4xl font-bold text-gray-900 dark:text-white uppercase my-2">{rule.title}</h2>
                                        {rule.content && rule.content.map((content, index) => (
                                            <>
                                                {content.title && (<h3 key={index} className="text-lg lg:text-xl my-8 font-bold text-gray-900 dark:text-white uppercase">{content.title}</h3>)}
                                                {content.subTitle && (<h4 key={index} className="text-lg lg:text-xl my-8 font-bold text-gray-900 dark:text-white uppercase">{content.subTitle}</h4>)}

                                                {content.description && (<p className="text-sm text-gray-700 dark:text-gray-200 my-5">{content.description}</p>)}

                                                {content.listRules && (
                                                    <ul className="list-disc list-inside text-sm mt-3">
                                                        {content.listRules.map((list, index) => (
                                                            <li key={index} className="text-gray-700 dark:text-gray-200 my-4">{list}</li>
                                                        ))}
                                                    </ul>
                                                )}

                                                {content.description2 && (<p className="text-sm text-gray-700 dark:text-gray-200 my-5">{content.description2}</p>)}
                                            </>
                                        ))}

                                        {rule.subContent && rule.subContent.map((subContent, index) => (
                                            <>
                                                {subContent.title && (<h3 key={index} className="text-lg lg:text-xl my-8 font-bold text-gray-900 dark:text-white uppercase">{subContent.title}</h3>)}
                                                {subContent.subTitle && (<h4 key={index} className="text-lg font-body my-5 font-medium text-gray-900 dark:text-white">{subContent.subTitle}</h4>)}

                                                {subContent.description && (<p className="text-sm text-gray-700 dark:text-gray-200 my-5">{subContent.description}</p>)}

                                                {subContent.listRules && (
                                                    <ul className="list-disc list-inside text-sm mt-3">
                                                        {subContent.listRules.map((list, index) => (
                                                            <li key={index} className="text-gray-700 dark:text-gray-200 my-4">{list}</li>
                                                        ))}
                                                    </ul>
                                                )}

                                                {subContent.description2 && (<p className="text-sm text-gray-700 dark:text-gray-200 my-5">{subContent.description2}</p>)}
                                            </>
                                        ))}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default LegalPolicy;
